import axios from 'axios';
import { setupUrl } from './support';

const evvntApi = axios.create({
  baseURL: setupUrl('api', 'v2'),
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
});

evvntApi.setAuthorizationToken = (token) => {
  if (token) {
    evvntApi.defaults.headers['Authorization'] = `Bearer ${token}`;
  } else {
    delete evvntApi.defaults.headers['Authorization'];
  }
};

export default evvntApi;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/lib/evvntApi.js